import { render, staticRenderFns } from "./MenuItemsEditorSidebar.vue?vue&type=template&id=92abe5b2"
import script from "./MenuItemsEditorSidebar.vue?vue&type=script&lang=js"
export * from "./MenuItemsEditorSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports